import { getSnowplowEventPayload, logAnalyticsEvents } from '../../analytics';
import { ANALYTICS_CATEGORIES, ANALYTICS_PROVIDERS, SNOWPLOW_EVENTS } from '../../analytics.const';

const { SNOWPLOW } = ANALYTICS_PROVIDERS;

export const triggerDistanceTooltipHoverEvent = (): void => {
	const snowplowEventPayload = getSnowplowEventPayload({
		category: ANALYTICS_CATEGORIES.VEHICLE_DETAILS,
		name: 'dlr_distance_tooltip_hover',
		schemaName: SNOWPLOW_EVENTS.HOVER.SCHEMA,
		version: SNOWPLOW_EVENTS.HOVER.VERSION,
	});

	logAnalyticsEvents([
		{
			eventPayload: snowplowEventPayload,
			provider: SNOWPLOW,
		},
	]);
};
